
import Vue from "vue";
import AppStockLocationSelect from "@/components/StockLocationSelect.vue";
import { StockService } from "@/services/stock-service";

export default Vue.extend({
	data(){
		return {
			locationId: 1
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			this.close();
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage((this.$ct("are-you-sure-you-want-to-set-stock-to-0").toString())).show();
			if (!confirm) return;
			await StockService.emptyStock(this.locationId);
		}
	},
	components: {
		AppStockLocationSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
